/**
 * @typedef {import('./harmonization-api').BulkResultItem} BulkResultItem
 * @typedef {Record<number, string>} AcceptedSelections
 */

/**
 * Count products that have at least one high confidence suggestion
 * @param {Array<BulkResultItem>} results
 * @returns {number}
 */
export const getHighConfidenceCount = (results) => {
  return results.filter((result) => result.suggestions?.some((suggestion) => suggestion.confidenceLevel === 'High')).length;
};

/**
 * Get next product that needs review (not accepted and not failed)
 * @param {Array<BulkResultItem>} results
 * @param {AcceptedSelections} acceptedSelections
 * @returns {number | null}
 */
export const getNextUnreviewedProductId = (results, acceptedSelections) => {
  const nextProduct = results.find((result) => {
    const isAccepted = result.productId in acceptedSelections;
    const isFailed = !!result.error;
    return !isAccepted && !isFailed;
  });
  return nextProduct?.productId ?? null;
};

/**
 * Get all high confidence codes as productId -> code map
 * @param {Array<BulkResultItem>} results
 * @returns {AcceptedSelections}
 */
export const getAllHighConfidenceCodes = (results) => {
  const highConfidenceCodes = {};
  results.forEach((result) => {
    const highConfidenceSuggestion = result.suggestions?.find((suggestion) => suggestion.confidenceLevel === 'High');
    if (highConfidenceSuggestion) {
      highConfidenceCodes[result.productId] = highConfidenceSuggestion.suggestedCode;
    }
  });
  return highConfidenceCodes;
};
